var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPurchaseOrder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.57164 12.4286H11.4288M14.8574 14.7143V3.28571C14.8574 2.67951 14.6165 2.09812 14.1879 1.66947C13.7592 1.24082 13.1778 1 12.5716 1H3.42878C2.82257 1 2.24119 1.24082 1.81254 1.66947C1.38388 2.09812 1.14307 2.67951 1.14307 3.28571V14.7143C1.14307 15.3205 1.38388 15.9019 1.81254 16.3305C2.24119 16.7592 2.82257 17 3.42878 17H12.5716C13.1778 17 13.7592 16.7592 14.1879 16.3305C14.6165 15.9019 14.8574 15.3205 14.8574 14.7143V14.7143ZM4.57164 5.57143H11.4288H4.57164ZM4.57164 9H11.4288H4.57164Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurchaseOrder);
export default __webpack_public_path__ + "static/media/purchaseOrder.58566d9412d9556d4a106f64b85cb0dc.svg";
export { ForwardRef as ReactComponent };